import { getBrandsList } from "api/brands";
import { getOneHRCategories } from "api/categories";
import FiltersMenuItem, {
  DropDownButton,
} from "components/Filters/FiltersMenuItem/FiltersMenuItem";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import { useLocation } from "react-router-dom";
import images from "ressources/images";
import { defaultFilters } from "../Search";

import "./SearchFiltersMenu.scss";

const SearchFilterMenu = (props) => {
  const { filters, onFiltersChange } = props;
  const { t } = useTranslation();
  // const location = useLocation();
  // const name = new URLSearchParams(location.search).get("query");
  const [currentFilters, setcurrentFilters] = useState(filters);

  const [brandsList, setBrandsList] = useState(null);
  const [categoriesList, setCategoriesList] = useState(null);
  const [typesList] = useState(["course", "article", "video", "product_catalog"]);
  const typeListWording = [
    t("course"),
    t("news"),
    t("video"),
    t("product_catalog"),
  ];
  const [unrollTypes, setUnrollTypes] = useState(false);
  const [valid, setValid] = useState(false);
  // Categories are hidden until we get the user type from server
  const [hideOneHrCategories, setHideOneHrCategories] = useState(true);

  const onUnrollTypes = (event) => {
    event.preventDefault();
    setUnrollTypes(!unrollTypes);
  };

  // If the user is allowed to get categories, display the dropdown
  const displayOneHrCategories = useCallback((categories) => {
    setCategoriesList(categories);
    setHideOneHrCategories(false);
  }, [setCategoriesList, setHideOneHrCategories])

  const getData = useCallback(() => {
    // Get brands
    getBrandsList()
      .then(res => setBrandsList(res))
      .catch(err => console.error(err));

    // Get OneHR Categories
    getOneHRCategories()
      .then(res => displayOneHrCategories(res))
      .catch(err => console.error(err));
  }, [setBrandsList, displayOneHrCategories]);

  useEffect(() => {
    getData();
  }, [getData]);

  const handleTypesChange = (event) => {
    const { name } = event.target;

    if (currentFilters["types"].includes(name)) {
      const tmp = [...currentFilters["types"]];
      const index = tmp.indexOf(name);

      tmp.splice(index, 1);
      setcurrentFilters({ ...currentFilters, types: tmp });
    } else {
      setcurrentFilters({
        ...currentFilters,
        types: [...currentFilters["types"], name],
      });
    }
  };

  useEffect(() => {
    const canSend = () => {
      const brandsLength = currentFilters["brands"].length;
      const typesLength = currentFilters["types"].length;
      const categoriesLength = currentFilters["categories"].length;
      const enableHR = currentFilters["enableHRContent"];
      const enableLuxe = currentFilters["enableLuxeContent"];

      const oneHr = enableHR && hideOneHrCategories;

      // Handle validation only if OneHr courses are not provided.
      if (oneHr) {
        if (!enableLuxe) return setValid(false);

        return setValid(brandsLength !== 0 || typesLength !== 0 || categoriesLength !== 0);
      }

      // If none of the content types are enabled, prevent validation.
      if (!enableHR && !enableLuxe) return setValid(false);

      const enabled = enableHR && enableLuxe;

      // If one of the two content is enabled, even without
      // brands/categories/types, allow validation.
      if (!enabled) return setValid(true);
      // If both of the content types are enabled
      // and no brands/types/categories are selected, prevent validation.
      else if (
        brandsLength === 0 &&
        typesLength === 0 &&
        categoriesLength === 0
      )
        return setValid(false);

      setValid(true);

    };

    canSend();
  }, [currentFilters, hideOneHrCategories]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onFiltersChange(currentFilters);
  };

  const handleReset = (e) => {
    e.preventDefault();
    setcurrentFilters(defaultFilters);
    onFiltersChange(defaultFilters);
  };

  return (
    <form className="wrapper" onSubmit={handleSubmit} onReset={handleReset}>
      {/* Brand content */}
      <FiltersMenuItem
        headerLabel={t("brand_content")}
        contentLabel={t("brands")}
        data={brandsList}
        filter="brands"
        filters={currentFilters}
        setfilters={setcurrentFilters}
        name="name"
        id="id"
        enableTarget="enableLuxeContent"
        src={images.luxe_content}
      />

      {/* Categories content */}
      {!hideOneHrCategories && <FiltersMenuItem
        headerLabel={t("corporate_content")}
        contentLabel={t("categories")}
        data={categoriesList}
        filter="categories"
        filters={currentFilters}
        setfilters={setcurrentFilters}
        name="title"
        id="id"
        enableTarget="enableHRContent"
        src={images.onehr_content}
      />}

      {/* Type */}
      <>
        <DropDownButton
          label={t("format")}
          open={unrollTypes}
          onClick={onUnrollTypes}
        />
        <div>
          {unrollTypes && (
            <div className="items_wrapper">
              {typesList.map((type, index) => (
                <div key={`type-${index}`} className="type_card">
                  <input
                    checked={currentFilters["types"].includes(type)}
                    type="checkbox"
                    id={type}
                    name={type}
                    onChange={(e) => handleTypesChange(e)}
                  />
                  <label className="type_card" htmlFor={type}>
                    <div className="wrapper">
                      <img alt="type" src={images[typesList[index]]}></img>
                    </div>
                    {typeListWording[index]}
                  </label>
                </div>
              ))}
            </div>
          )}
        </div>
      </>

      <div className="validation wall_filter_end_form container-width">
        <input
          disabled={!valid}
          className={`${valid ? "can--send" : ""}`}
          type="submit"
          value={t("Validate")}
        />
        <input type="reset" value={t("Reset")} />
      </div>
    </form>
  );
};

export default SearchFilterMenu;
